import { countries, basins, crops } from "./entity-model";

export const steps = [
  { name: "scope", title: "Home", shortTitle: "Home", index: 0 },
  { name: "accounting", title: "Accounting", shortTitle: "Acc", index: 1 },
  { name: "sustainability", title: "Sustainability", shortTitle: "Sust", index: 2 },
  { name: "response", title: "Response Formulation", shortTitle: "Resp", index: 3 }
];

export const viewTypes = {
  "map": { name: "map", icon: "map.svg" },
  "table": { name: "table", icon: "table.svg" },  // croptable,
                                                  // production account table, production account table 2, production account table 3,
                                                  // production sustain blue table, production sustain grey table,
                                                  // production respond blue table, production respond grey table
  "pie-chart": { name: "pie-chart", icon: "pie-chart.svg" },  // cropchart
  "bar-chart": { name: "bar-chart", icon: "bar-chart.svg" },  // barchart
  "hydrograph": { name: "hydrograph", icon: "hydrograph.svg" }
};

export const assessmentTypes = {
  "countries": {
    name: "countries",
    layerName: "Countries",
    idPropertyName: "countryID",
    steps: [
      {
        views: []
      }, {
        views: [{
          viewType: viewTypes["map"],
          viewColors: [ "green", "blue", "grey", "total" ],
          hasCrops: true
        }, {
          viewType: viewTypes["table"]
        }, {
          viewType: viewTypes["pie-chart"],
          viewColors: [ "green", "blue", "grey" ]
        }, {
          viewType: viewTypes["bar-chart"],
          hasCrops: true
         }]
      }, {
        views: [{
          viewType: viewTypes["map"],
          viewColors: [ "blue", "grey" ],
          hasCrops: true
        }, {
          viewType: viewTypes["table"],
          viewColors: [ "blue", "grey" ],
          hasCrops: true
        }]
      }, {
        views: [{
          viewType: viewTypes["table"],
          viewColors: [ "blue", "grey" ],
          hasCrops: true
        }]
      }
    ],
    countriesOrBasins: countries
  },
  "basins": {
    name: "basins",
    layerName: "Basins",
    idPropertyName: "basinID",
    steps: [
      {
        views: []
      }, {
        views: [{
          viewType: viewTypes["map"],
          viewColors: [ "green", "blue", "grey", "total" ],
          hasCrops: true
        }, {
          viewType: viewTypes["table"]
        }, {
          viewType: viewTypes["pie-chart"],
          viewColors: [ "green", "blue", "grey" ]
        }, {
          viewType: viewTypes["bar-chart"],
          hasCrops: true
        }]
      }, {
        views: [{
          viewType: viewTypes["map"],
          viewColors: [ "blue", "grey" ],
          hasCrops: true
        }, {
          viewType: viewTypes["table"],
          viewColors: [ "blue", "grey" ],
          hasCrops: true
        }, {
          viewType: viewTypes["hydrograph"]
        }]
      }, {
        views: [{
          viewType: viewTypes["table"],
          viewColors: [ "blue", "grey" ],
          hasCrops: true
        }]
      }
    ],
    countriesOrBasins: basins
  },
  "world": {
    name: "world",
    steps: [
      {
        views: []
      }, {
        views: [{
          viewType: viewTypes["map"],
          viewColors: [ "green", "blue", "grey", "total" ],
          hasCrops: true
        }, {
          viewType: viewTypes["table"]
        }, {
          viewType: viewTypes["pie-chart"],
          viewColors: [ "green", "blue", "grey" ]
        }, {
          viewType: viewTypes["bar-chart"],
          hasCrops: true
        }]
      }, {
        views: [{
          viewType: viewTypes["map"],
          viewColors: [ "blue", "grey" ],
          hasCrops: true
        }, {
          viewType: viewTypes["table"],
          viewColors: [ "blue", "grey" ],
          hasCrops: true
        }]
      }, {
        views: [{
          viewType: viewTypes["table"],
          viewColors: [ "blue", "grey" ],
          hasCrops: true
        }]
      }
    ],
    countriesOrBasins: null
  }
};

function Assessment() {
  this.assessmentType = null;
  this.step = steps[0];
  this.viewType = null;
  this.viewColor = "blue";  // green, blue, grey, total
  this.countriesOrBasins = [];
  this.crop = null;
}

Assessment.prototype.setAssessmentType = function(assessmentType) {
  if (typeof assessmentType == "string") {
    assessmentType = assessmentTypes[assessmentType];
  }
  if (this.assessmentType == assessmentType) {
    return;
  }
  
  this.assessmentType = assessmentType;
  //if ((assessmentType == null) || (assessmentType.countriesOrBasins != null)) {
    this.setStep(steps[0]);
  //} else {
  //  this.setStep(steps[1]);
  //}
  
  this.countriesOrBasins = [];
}

Assessment.prototype.setStep = function(step) {
  if (typeof step == "number") {
    step = steps[step];
  }
  if ((this.assessmentType == null) && (step != steps[0])) {
    throw new Error("Cannot set step when there is no assessment type.");
  }
  
  this.step = step;
  this.alignViewType();
}

Assessment.prototype.nextStep = function() {
  if (this.assessmentType == null) {
    throw new Error("Cannot set next step when there is no assessment type.");
  }
  if (this.step.index == steps.length - 1) {
    throw new Error("Cannot set step beyond the last step.");
  }
  
  this.step = steps[this.step.index + 1];
  this.alignViewType();
}

Assessment.prototype.previousStep = function() {
  if (this.step.index == 0) {
    throw new Error("Cannot set step before the first step.");
  }
  
  this.step = steps[this.step.index - 1];
  this.alignViewType();
}

Assessment.prototype.setViewType = function(viewType) {
  if (typeof viewType == "string") {
    viewType = viewTypes[viewType];
  }
  
  this.viewType = viewType;
  this.alignViewType();
}

Assessment.prototype.alignViewType = function() {
  if (this.step == steps[0]) {
    this.viewType = null;
    return;
  }
  
  if ((this.viewType == null) || !this.assessmentType.steps[this.step.index].views.find(view => view.viewType == this.viewType)) {
    this.viewType = this.assessmentType.steps[this.step.index].views[0].viewType;
  }
  
  this.alignViewColor();
}

Assessment.prototype.setViewColor = function(viewColor) {
  this.viewColor = viewColor;
  this.alignViewColor();
}

Assessment.prototype.alignViewColor = function() {
  if (this.viewType == null) {
    return;
  }
  
  const view = this.assessmentType.steps[this.step.index].views.find(view => view.viewType == this.viewType);
  if (view.viewColors == null) {
    return;
  }
  
  if (view.viewColors.indexOf(this.viewColor) == -1) {
    this.viewColor = view.viewColors[0];
  }
}

Assessment.prototype.getCountryOrBasinName = function(multipleNames) {
  if (assessment.assessmentType.name == "countries") {
    if (assessment.countriesOrBasins.length == 1) {
      return assessment.countriesOrBasins[0].name;
    }
    if (multipleNames) {
      return assessment.countriesOrBasins.map((o, i, a) => (i == 0)? o.name: (i < a.length - 1)? ", " + o.name: " and " + o.name).join("");
    }
    return "the selected country";
  } else if (assessment.assessmentType.name == "basins") {
    if (assessment.countriesOrBasins.length == 1) {
      return "the " + assessment.countriesOrBasins[0].name + " basin";
    }
    if (multipleNames) {
      return "the " + assessment.countriesOrBasins.map((o, i, a) => (i == 0)? o.name: (i < a.length - 1)? ", " + o.name: " and " + o.name).join("") + " basins";
    }
    return "the selected river basin";
  } else {
    return "the world";
  }
}

Assessment.prototype.setCrop = function(crop) {
  if (typeof crop == "number") {
    crop = crops.filter(c => c.cropID == crop)[0];
  }
  
  this.crop = crop;
}

export const assessment = new Assessment();

